import type { PhraseAnonymizationTag } from '@/entities/conversations';
import { type MarkedTextPart, parseMarkedText, type TextMarker } from '@/shared/lib';

/** Подстановка анонимизации в тексте реплики: `[<Метка>:<номер>]`, например `[Имя:3]`. */
const ANONYMIZATION_TAG_PATTERN = /\[([^[\]:]+):\d+\]/;

/** Распознанная подстановка: метка скрытых данных и исходное значение, если оно пришло с транскриптом. */
export type AnonymizationTagPart = { label: string; value?: string };

/** Часть текста реплики: обычный текст либо подстановка анонимизации. */
export type PhraseTextPart = MarkedTextPart<AnonymizationTagPart>;

/**
 * Разбирает текст реплики на обычный текст и подстановки анонимизации.
 *
 * Значение подстановки берётся по самому тегу, а не по позиции в тексте: облако реплики
 * склеивается из нескольких фраз, и позиции внутри исходной фразы в нём не сохраняются.
 * Тег, для которого значение не пришло, остаётся нераскрываемым.
 */
export const parsePhraseText = (text: string, tags: PhraseAnonymizationTag[]): PhraseTextPart[] => {
  const valueByPlaceholder = new Map(tags.map((tag) => [tag.placeholder, tag.value]));

  const anonymizationTagMarker: TextMarker<AnonymizationTagPart> = {
    pattern: ANONYMIZATION_TAG_PATTERN,
    parse: (match) => ({ label: match[1], value: valueByPlaceholder.get(match[0]) }),
  };

  return parseMarkedText(text, [anonymizationTagMarker]);
};
